var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephoner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#1f3d60",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M973 4866 c-72 -23 -104 -50 -308 -258 -205 -208 -244 -260 -307 -403 -91 -206 -101 -457 -27 -679 55 -166 353 -688 621 -1087 456 -683 863 -1089 1538 -1536 405 -269 932 -565 1095 -616 279 -87 576 -46 814 113 54 37 155 125 273 240 157 152 192 192 219 245 29 59 31 70 27 147 -2 60 -9 96 -25 128 -16 32 -148 170 -455 476 -406 405 -436 433 -488 450 -70 23 -150 23 -220 0 -50 -17 -77 -40 -300 -262 -135 -134 -254 -244 -263 -244 -10 0 -66 24 -126 54 -446 222 -847 593 -1176 1086 -107 161 -235 384 -235 410 0 8 104 119 231 245 274 273 284 288 284 420 0 78 -4 96 -27 140 -19 36 -149 172 -450 472 -345 344 -432 426 -473 444 -61 27 -164 34 -222 15z m130 -210 c18 -8 208 -190 432 -415 l400 -401 0 -45 0 -44 -241 -243 c-152 -153 -247 -258 -259 -283 -10 -23 -18 -64 -19 -95 0 -63 19 -111 114 -277 367 -640 865 -1137 1413 -1408 170 -85 210 -94 294 -70 56 16 68 27 309 266 l251 249 44 0 44 0 414 -414 414 -414 -5 -49 c-6 -47 -9 -51 -174 -212 -93 -89 -197 -183 -231 -207 -129 -93 -266 -137 -428 -136 -149 0 -222 21 -410 117 -498 256 -1010 586 -1380 890 -477 392 -885 914 -1337 1711 -200 353 -228 417 -248 567 -21 155 16 327 102 472 47 80 372 418 423 441 38 17 39 17 78 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoner);
export default __webpack_public_path__ + "static/media/telephoner.de2c6dd8c1e7af809b78d5a4b606e62e.svg";
export { ForwardRef as ReactComponent };